<template>
    <svg-icon
        :color="Color.gray400"
        :icon="channelIcon"
        :size="IconSize.sm"
        is-custom-icon
    />
    <span>&nbsp;{{ channel.label }}</span>
</template>

<script setup lang="ts">
    import { computed } from 'vue';
    import { IconSize, SvgIcon, Color } from '@keyvue/one-ui';
    import IconChannelOnline from '@assets/icons/channels/ChannelOnline.svg?component';
    import IconChannelRealworks from '@assets/icons/channels/ChannelRealworks.svg?component';
    import IconChannelUser from '@assets/icons/channels/ChannelUser.svg?component';
    import { Channel } from '@keyvue/one-api-client';

    export interface Props {
        channel: Channel,
    }

    const props = defineProps<Props>();

    const channelIconMap = {
        [Channel.USER.toString()]: IconChannelUser,
        [Channel.ONLINE.toString()]: IconChannelOnline,
        [Channel.REALWORKS.toString()]: IconChannelRealworks,
    };

    const channelIcon = computed(() => channelIconMap[props.channel.toString()]);
</script>
